// OWNER: documents module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Pages are lazy-loaded so each feature is its own chunk. Add routes here; don't edit the router.
import type { RouteObject } from 'react-router';

const pages = () => import('./pages');

export const routes: RouteObject[] = [
  { path: 'records/documents', lazy: async () => ({ Component: (await pages()).DocumentsPage }) },
  { path: 'records/documents/upload', lazy: async () => ({ Component: (await pages()).UploadPage }) },
  { path: 'records/documents/:documentId', lazy: async () => ({ Component: (await pages()).DocumentDetailPage }) },
];
